import * as React from 'react';
import _ from 'lodash';

export default class BaseAnimation extends React.Component {
    static defaultProps = {
        duration: 200,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onAnimationFinished: () => {},
        hideChildren: true
    };

    state = {
        animationFinished: true
    };

    base = React.createRef();

    componentDidUpdate(previousProps: $TSFixMe) {
        // @ts-expect-error TS(2339): Property 'style' does not exist on type 'Readonly<... Remove this comment to see the full error message
        if (!_.isEqual(previousProps.style, this.props.style)) {
            this.reset();
        }
    }

    handleTransitionEnd = (e: $TSFixMe) => {
        if (e.target === this.base.current) {
            this.setState({ animationFinished: true });
            // @ts-expect-error TS(2339): Property 'onAnimationFinished' does not exist on t... Remove this comment to see the full error message
            this.props.onAnimationFinished(this.props.active);
        }
    };

    reset() {
        this.setState({ animationFinished: false });
    }

    setRef = (ref: $TSFixMe) => {
        // @ts-expect-error TS(2339): Property 'setRef' does not exist on type 'Readonly... Remove this comment to see the full error message
        const { setRef } = this.props;
        if (setRef) {
            setRef.current = ref;
        }
        // @ts-expect-error TS(2540): Cannot assign to 'current' because it is a read-on... Remove this comment to see the full error message
        this.base.current = ref;
    };

    render() {
        // @ts-expect-error TS(2339): Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
        const { children, duration, className, style, active, hideChildren } = this.props;
        const animationFinished = duration > 0 ? this.state.animationFinished : true;
        const showChildren = hideChildren ? active || !animationFinished : true;
        return (
            <div style={style} onTransitionEnd={this.handleTransitionEnd} ref={this.setRef} className={className}>
                {showChildren && children}
            </div>
        );
    }
}
